<template>
    <div >
        <b-row>
            <b-col cols="12">
                <b-form>
                    <b-row>
                        <b-col cols="12">
                            <h3 v-if="isEdit">Edit Location <b-button class="thin-button" size="sm" @click="addNew" variant="primary">New Location</b-button></h3>
                            <h3 v-else>Add New Location</h3>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col cols="12">
                            <label for="">Location Type</label>
                            <vue-typeahead-bootstrap
                            :showOnFocus="true"
                            @hit="findType($event)"
                            v-model="typeahead_query"
                            :data="type_names"
                            :minMatchingChars="1"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col cols="12">
                            <label for="">Location Name</label>
                            <b-form-input v-model="form_data.location_name"></b-form-input>
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col cols="12">
                            <label for="">Location Size (sqr m)</label>
                            <b-form-input v-model="form_data.location_sqm"></b-form-input>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-row>
        <b-button class="w-100" variant="primary" @click="saveLocation">Save</b-button>
    </div>
</template>

<script>
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import _ from 'lodash';
export default {
    props:{
        types:{
            default:function(){
                return [];
            }
        },
    },
    data:() => ({
        isEdit: false,
        //* Uid for the add locations form - unused
        uid: '6166de010594f',
        typeahead_query: '',
        form_data:{
            location_name: '',
            location_sqm: '',
            location_type_id: '',
        },
        editData:null,
        has_form_loaded: false,
    }),
    components:{
        VueTypeaheadBootstrap
    },
    computed:{
        ...facilityAdminState,
        type_names(){
            let names = [];
            this.types.forEach( type => {
                names.push(type.name);
            })
            return names
        }
    },
    methods:{
        ...facilityAdminMethods,
        /*updateFormData(newData){
            console.log(newData)
            this.form_data = newData.form_data;
        },*/
        saveLocation(){
            let params = {
                id: -1,
                location_type_id: this.form_data.location_type_id,
                location_name: this.form_data.location_name,
                location_sqm: this.form_data.location_sqm,
            }
            if(this.isEdit){
                params.id = this.editData.id;
            }

            this.saveClientLocation(params)
            .then(()=>{
                this.loadClientLocations();
                this.form_data = {
                    location_name: '',
                    location_sqm: '',
                    location_type_id: '',
                }
                this.editData = null;
                this.isEdit = false;
                this.typeahead_query = '';
            })



            
        },
        findType(string){
            let obj = _.find(this.types, { name : string });
            if(obj != undefined){
                this.form_data.location_type_id = obj.id;
            }
        },
        editLocation(id){
            let index = _.findIndex(this.client_locations, {id: id});
            if(index != -1){
                this.isEdit = true;
                this.editData = this.client_locations[index];
                this.form_data.location_type_id = this.editData.location_type_id;
                this.form_data.location_name = this.editData.name;
                this.form_data.location_sqm = this.editData.sqm;
                let obj = _.find(this.types, { id : this.editData.location_type_id });
                if(obj != undefined){
                    this.typeahead_query = obj.name;
                }
            }
            else{
                this.isEdit = false;
            }
        },
        addNew(){
            //* Clear form input and other related vars
            this.isEdit = false;
            this.form_data = {
                location_name: '',
                location_sqm: '',
                location_type_id: '',
            }
            this.typeahead_query = '';

            //* Clear table selection css when adding a new item
            /* eslint-disable-next-line */
            let table = $$('locationsTable');
            if(table != undefined){
                table.clearSelection();
            }
            
        }
    },
    mounted(){
        this.$eventHub.$on('editLocation', this.editLocation);
    },
    beforeDestroy(){
        this.$eventHub.$off('editLocation');
    }
}
</script>

<style>

</style>